"use client";

import * as React from "react";
import { useAuth } from "./auth-context";
import { getVerticalConfig, type VerticalConfig } from "@/lib/verticals";
import type { Vertical } from "@/lib/types";

interface VerticalContextType {
  vertical: Vertical;
  config: VerticalConfig;
}

const VerticalContext = React.createContext<VerticalContextType | undefined>(
  undefined
);

export function VerticalProvider({ children }: { children: React.ReactNode }) {
  const { user } = useAuth();

  const vertical: Vertical = user?.clinic?.vertical || "HEALTHCARE";
  const config = getVerticalConfig(vertical);

  return (
    <VerticalContext.Provider value={{ vertical, config }}>
      {children}
    </VerticalContext.Provider>
  );
}

export function useVertical() {
  const context = React.useContext(VerticalContext);
  if (context === undefined) {
    throw new Error("useVertical must be used within a VerticalProvider");
  }
  return context;
}
